import React, { useState } from "react";
import UseGetDashBoardWithParams from "../../../../../Components/Hooks/useDashboardDataParams";
import capitalizeFirstLetter from "../../../../../Components/Utils/Funcs";

function CostSavingByProcurmentTeamProdash() {
  const [params, setParams] = useState({
    period: "monthly",
  });
  const [selectedPeriod, setSelectedPeriod] = useState("monthly");

  const { data, loading } = UseGetDashBoardWithParams(`/dashboard/cost-save-by-procurement`, params);

  const hanChange = (e) => {
    setParams({
      period: e.target.value,
    });
    setSelectedPeriod(e.target.value);
  };

  const periods = [
    { value: "monthly", option: "Monthly" },
    { value: "quarterly", option: "Quarterly" },
    { value: "halfyearly", option: "Half Yearly" },
    { value: "yearly", option: "Yearly" },
  ];

  const dataDummy =
    data?.top_orders_by_value?.map((product) => ({
      name: product.name,
      count: product.count,
      value: product.value,
      ordered_price: product.ordered_price,
      difference: product.difference,
    })) || [];

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-teal-50 flex items-center justify-center text-teal-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Cost Savings by Procurement Team</h3>
        </div>

        <select
          value={selectedPeriod}
          onChange={hanChange}
          className="bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-medium text-gray-700 outline-none"
        >
          {periods.map((period) => (
            <option key={period.value} value={period.value}>
              {period.option}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Member</th>
                <th className="py-2 px-1 text-center">Count</th>
                <th className="py-2 px-2 text-left">Quote Value</th>
                <th className="py-2 px-2 text-left">Ordered Price</th>
                <th className="py-2 px-2 text-right">Savings Diff</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {dataDummy && dataDummy.length > 0 ? (
                dataDummy.map((value, index) => {
                  const [valueCurrency, valueNumeric] = (value.value || "N/A").toString().split(" ");
                  const [orderedCurrency, orderedNumeric] = (value.ordered_price || "N/A").toString().split(" ");
                  const [differenceCurrency, differenceNumeric] = (value.difference || "N/A").toString().split(" ");

                  const formattedValue = valueNumeric
                    ? Number(valueNumeric).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : "N/A";
                  const formattedOrdered = orderedNumeric
                    ? Number(orderedNumeric).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : "N/A";
                  const formattedDifference = differenceNumeric
                    ? Number(differenceNumeric).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : "N/A";

                  return (
                    <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                      <td className="py-2.5 px-2 font-medium text-gray-800 truncate max-w-[110px]">
                        {capitalizeFirstLetter(value?.name || "N/A")}
                      </td>
                      <td className="py-2.5 px-1 text-center font-bold text-gray-700">{value?.count || 0}</td>
                      <td className="py-2.5 px-2 text-gray-600 font-medium">{`${valueCurrency || ""} ${formattedValue}`}</td>
                      <td className="py-2.5 px-2 text-blue-600 font-semibold">{`${orderedCurrency || ""} ${formattedOrdered}`}</td>
                      <td className="py-2.5 px-2 text-right">
                        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-teal-50 text-teal-700 border border-teal-200/50">
                          {`${differenceCurrency || ""} ${formattedDifference}`}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} className="py-6 text-center text-gray-400">
                    No team savings data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default CostSavingByProcurmentTeamProdash;